<div class="page-container">
  <div class="page-header d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3 mb-lg-4">
    <h1 class="mb-0">Current Instant Rates</h1>
    <button type="button" class="btn btn-light d-flex align-items-center gap-2" (click)="goTo('/instant-rate-manager')">
      <i class="bi bi-arrow-left" aria-hidden="true"></i>
      Instant Rates Manager
    </button>
  </div>

  <div class="grid-container d-flex flex-column gap-4 w-100">
    <div class="d-flex flex-row justify-content-between">
      <div class="d-flex gap-2">
        <button type="button" (click)="openCreateRateModal()" class="rate-btn rate-btn--primary">
          <i class="bi bi-plus-circle" aria-hidden="true"></i>
          Add Rate
        </button>

        <button type="button" (click)="openBulkCreateRateModal()" class="rate-btn rate-btn--outline">
          <i class="bi bi-file-earmark-arrow-up" aria-hidden="true"></i>
          Import
        </button>
      </div>

      <div class="btn-group" role="group">
        <button class="rate-btn rate-btn--outline" type="button" (click)="downloadCsvRate('all')" [disabled]="totalRates === 0">
          <i class="bi bi-download" aria-hidden="true"></i>
          Export as CSV
        </button>
        <div class="btn-group" ngbDropdown role="group">
          <button
            type="button"
            class="rate-btn rate-btn--outline rate-btn--split dropdown-toggle dropdown-toggle-split"
            ngbDropdownToggle
            [disabled]="totalRates === 0"
            aria-label="Export options"
          ></button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <button ngbDropdownItem (click)="downloadCsvRate('all')">All Records</button>
            <button ngbDropdownItem (click)="downloadCsvRate('current')">Current Page</button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap align-items-center justify-content-between w-100 gap-3">
      <div class="d-flex flex-wrap align-items-center gap-3 flex-grow-1" style="min-width: 250px">
        <!-- <div #groupContainer class="position-relative flex-grow-1 group-select"
        style="min-width: 100px; max-width: 200px;">
        <ng-select #groupSelector class="w-100 custom-select-icon no-caret" [items]="groupArray"
          (change)="onGroupChange($event)" placeholder="Search by group">
        </ng-select>
        <i
          class="bi bi-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted pointer-events-none"></i>
      </div> -->
        <div class="flex-grow-1" style="min-width: 100px; max-width: 200px">
          <ng-select class="w-100" [items]="rateCategoryArray" (change)="onRateCategoryChange($event)" placeholder="Select rate category"></ng-select>
        </div>
      </div>
      <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module" (onClearFilters)="clearFiltersExternally()"></app-saved-search>
    </div>

    <div *ngIf="selectedRowCount > 0" class="bulk-actions-container d-flex flex-wrap align-items-center gap-3">
      <div ngbDropdown class="d-inline-block" #bulkDropdown="ngbDropdown">
        <button type="button" class="bulk-action-btn" ngbDropdownToggle [class.bulk-action-btn-open]="bulkDropdown.isOpen()">
          Bulk Action
          <i class="bi bi-chevron-down" aria-hidden="true"></i>
        </button>
        <div ngbDropdownMenu class="bulk-actions-menu">
          <div class="more-actions-label">Bulk action</div>
          <button type="button" class="more-actions-item" (click)="openBulkUpdateModal(); bulkDropdown.close()">Update selected</button>
          <button type="button" class="more-actions-item" (click)="bulkSubmit(); bulkDropdown.close()">Submit for review</button>
          <button type="button" class="more-actions-item" (click)="bulkMoveToDraft(); bulkDropdown.close()">Move to draft</button>
          <button type="button" class="more-actions-item more-actions-item--danger" (click)="bulkDeactivate(); bulkDropdown.close()">Deactivate</button>
          <button type="button" class="more-actions-item more-actions-item--danger" (click)="bulkDelete(); bulkDropdown.close()">Delete</button>
        </div>
      </div>
      <span class="selected-count">{{ selectedRowCount }} rate(s) selected</span>
    </div>

    <div *ngIf="hasPendingEdits" class="pending-edits-bar d-flex align-items-center gap-2">
      <i class="bi bi-pencil-square text-warning"></i>
      <span class="fw-semibold">{{ pendingEdits.size }} rate(s) modified</span>
      <div class="ms-auto d-flex gap-2">
        <button type="button" class="rate-btn rate-btn--outline rate-btn--sm" (click)="discardPendingEdits()">
          <i class="bi bi-x-circle" aria-hidden="true"></i>
          Discard
        </button>
        <button type="button" class="rate-btn rate-btn--primary rate-btn--sm" (click)="submitPendingEdits()">
          <i class="bi bi-check-circle" aria-hidden="true"></i>
          Submit Changes
        </button>
      </div>
    </div>

    <ag-grid-angular
      tkGrid
      class="w-100"
      style="height: 600px"
      [columnDefs]="columnDefs"
      [rowSelection]="rowSelection"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [appSavedSearchSync]="savedSearch"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged()"
      (cellValueChanged)="onCellValueChanged($event)"
    ></ag-grid-angular>
  </div>
</div>

<ng-template #bulkUpdateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Bulk Update Selected Rates</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body d-flex flex-column gap-3">
    <p class="text-muted mb-0">Update one field across {{ selectedRowCount }} selected rate(s). Changes are staged until you click Submit Changes.</p>
    <div>
      <label class="form-label fw-semibold" for="bulkUpdateField">Field</label>
      <select class="form-select" id="bulkUpdateField" [(ngModel)]="bulkUpdateField" (ngModelChange)="onBulkUpdateFieldChange()">
        <option value="" disabled>Select field</option>
        <option *ngFor="let field of getBulkUpdateFields()" [value]="field.field">{{ field.label }}</option>
      </select>
    </div>
    <div *ngIf="isTransitDaysBulkUpdate">
      <label class="form-label fw-semibold" for="bulkTransitDaysMode">Transit Days Action</label>
      <select class="form-select" id="bulkTransitDaysMode" [(ngModel)]="bulkTransitDaysMode">
        <option *ngFor="let option of bulkTransitDaysModeOptions" [value]="option.value">{{ option.label }}</option>
      </select>
      <small class="text-muted">
        {{ bulkTransitDaysMode === 'add_on_top' ? "Adds the value below to each rate's existing transit days." : "Replaces each rate's transit days with the value below." }}
      </small>
    </div>
    <div *ngIf="selectedBulkFieldConfig as fieldConfig">
      <label class="form-label fw-semibold" for="bulkUpdateValue">
        {{
          isTransitDaysBulkUpdate && bulkTransitDaysMode === 'add_on_top'
            ? 'Days
        to Add'
            : 'New Value'
        }}
      </label>
      <select *ngIf="fieldConfig.type === 'select'" class="form-select" id="bulkUpdateValue" [(ngModel)]="bulkUpdateValue">
        <option *ngFor="let option of fieldConfig.options" [value]="option">{{ option }}</option>
      </select>
      <input *ngIf="fieldConfig.type === 'number'" type="number" class="form-control" id="bulkUpdateValue" [(ngModel)]="bulkUpdateValue" min="0" />
      <input *ngIf="fieldConfig.type === 'text'" type="text" class="form-control" id="bulkUpdateValue" [(ngModel)]="bulkUpdateValue" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="applyBulkUpdate(modal)" [disabled]="!bulkUpdateField">Apply to Selected</button>
  </div>
</ng-template>
